import React from "react";
import { Link, NavLink } from "react-router-dom";

export default function ServicePlanBox({
  planid,
  title,
  titleslug,
  selling_price,
  price,
  service_tag,
}) {
  const serviceTag = service_tag.split(",");

  return (
    <>
      <div className="pricing-table">
        <div className="inner-box">
          <div className="">
            <div className="title">
              <Link to={`/plans/${titleslug}`}>{title}</Link>
            </div>
            <div className="price">
              <Link to={`/plans/${titleslug}`}>
                {" "}
                ₹{selling_price}{" "}
                <span>
                  <del className="croosPrice">{price}</del>
                </span>
              </Link>{" "}
              {/* <span className="duration">/ {plan_type}</span> */}
            </div>
            <div className="table-content">
              <ul>
                {serviceTag &&
                  serviceTag.map((valuetag, index) => (
                    <li key={index} className="priceTypetags">
                      <i className="fa fa-check" aria-hidden="true"></i>
                      <span>{valuetag}</span>
                    </li>
                  ))}
              </ul>
            </div>
            <NavLink to={`/plans/${titleslug}`} className="planviewdetailsBTN">
              View Details
            </NavLink>
          </div>
          <div className="table-footer">
            <NavLink
              to={`/checkout/${titleslug}`}
              className="theme-btn btn-style-three"
            >
              Book Now
            </NavLink>
          </div>
        </div>
      </div>
    </>
  );
}
